import {ICellRendererParams} from "@ag-grid-community/core";
import {Popover, PopoverPosition, Tooltip} from "@blueprintjs/core";
import {duotone, solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {JobStopStatus, jobStopStatusToString} from "../../../utils/stops/StopUtils";

const StopStatusRenderer = (props: ICellRendererParams) => {
  const {value: jobStopStatus} = props;
  // queued = hourglass, completed = checkmark, active = nothing
  let icon: JSX.Element = <div style={{visibility: "hidden"}}>{"Active"}</div>;
  // assume status is active...
  let tooltip: string = jobStopStatusToString(JobStopStatus.ACTIVE);

  if (jobStopStatus === JobStopStatus.QUEUED) {
    icon = (
      <FontAwesomeIcon
        data-testid={"job-stop-status-hourglass-icon"}
        size={"1x"}
        color={"#161616"}
        icon={duotone("hourglass-start")}
      />
    );
    tooltip = jobStopStatusToString(JobStopStatus.QUEUED);
  } else if (jobStopStatus === JobStopStatus.COMPLETED) {
    icon = (
      <FontAwesomeIcon data-testid={"job-stop-status-check-icon"} size={"1x"} color={"#161616"} icon={solid("check")} />
    );
    tooltip = jobStopStatusToString(JobStopStatus.COMPLETED);
  }
  return (
    <Popover
      className=""
      placement="top"
      renderTarget={() => (
        <Tooltip
          content={<div data-testid={"job-stop-status-tooltip-content"}>{tooltip}</div>}
          openOnTargetFocus={false}
          position={PopoverPosition.TOP}
          usePortal={true}
          intent={"primary"}
        >
          {icon}
        </Tooltip>
      )}
    ></Popover>
  );
};
export default StopStatusRenderer;
